<template>
    <div style="height:100%;overflow:hidden;position: relative;background: #eaeaea">
        <div class="top-field">
            <img src="../assets/img/query_bg.jpg" style="width: 100%"/>
        </div>
        <div class="relative-1">
            <div class="vertical-center" @click="back">
                <img style="width: 20px;margin-top: 20px;margin-left: 27px" src="../assets/img/return_trans.png" />
                <div style="color: white;font-size: 20px;margin-top: 20px;">返回</div>
            </div>
            <div class="title">绑定就诊号</div>
            <div class="form-panel">
                <div class="form-item">
                    <!--<div class="form-label">手机号码</div>-->
                    <input disabled v-model="form.name" class="form-input" placeholder="下方输入在诊所留存的手机号"/>
                </div>
                <div class="form-item" v-if="!hasBind">
                    <!--<div class="form-label">病历号</div>-->
                    <input v-model="form.phone" class="form-input" type="number" placeholder="请填写就诊预留手机号码"/>
                </div>
                <div class="form-item" v-else>
                    <!--<div class="form-label">病历号</div>-->
                    <div class="form-input">病历号：{{bindNo}}</div>
                </div>
                <div v-if="!hasBind" @click="submit" class="form-button">确认绑定</div>
                <div v-else class="form-button" style="background: #aaaaaa">已绑定</div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../api";
    import utils from "../common/utils";
    import {Indicator, Toast} from 'mint-ui';


    export default {
        name: "RegistSubscribe",
        data() {
            return {
                YY_USER_ID: "",
                form: {
                    name: "",
                    phone: ""
                },
                hasBind: false,
                bindNo: ""
            }
        },
        methods: {
            submit: function () {
                var phoneReg = /^[1][3,4,5,7,8][0-9]{9}$/;
                // if (!phoneReg.test(this.form.phone)) {
                //     Toast("请填写正确的手机号码");
                //     return;
                // }
                Indicator.open('加载中...');
                var url = "http://wx.kq123.com:10123/QSYYAjaxServer/PBClientTest?guid=" + this.$store.state.baseInfo.clientID + "&sql=bd>xh>>" + this.form.phone + "w>>" + this.$route.query.openId;
                api.corsGet(url, (res) => {
                    if (res != "not find client") {
                        if (res == "成功绑定！") {
                            this.loadBindInfo();
                            Toast(res);
                            setTimeout(() => {
                                history.back();
                            },3000);
                        } else {
                            Toast(res);
                        }
                    } else {
                        Toast("诊所信息错误");
                    }
                    Indicator.close();
                }, (err) => {
                    Indicator.close();
                    Toast("网络出错，请稍后再试");
                    console.log(err);
                })
            },
            loadBindInfo: function () {
                var _this = this;
                var url = "http://wx.kq123.com:10123/QSYYAjaxServer/PBClientTest?guid=" + this.$store.state.baseInfo.clientID + "&sql=is>" + this.$route.query.openId;
                Indicator.open('加载中...');

                api.corsGet(url, (res) => {
                    Indicator.close();
                    console.log(res);
                    if (res != "not find client") {
                        if (res == "") {

                        } else {
                            _this.hasBind = true;
                            _this.bindNo = res;
                        }
                    }
                }, (err) => {
                    Toast("网络出错，请稍后再试");
                    Indicator.close();
                    console.log(err);
                })
            },
            back:function (){
                history.back()
            }
        },
        created() {
            var _this = this;
            utils.doIF(() => {
                _this.form.name = this.$store.state.baseInfo.name;
                _this.loadBindInfo();
            }, () => {
                console.log(2);
                return !!this.$store.state.baseInfo && this.$route.query.openId;
            });
        },
        mounted() {
            var _this = this;
            window._this = this;
        }
    }
</script>

<style scoped>
    .top-field {
        width: 100%;
        height: 0;
    }

    .title {
        color: white;
        font-size: 20px;
        padding: 27px;
        letter-spacing: 3px;
    }

    .title:after {
        content: "";
        display: block;
        width: 50px;
        height: 1px;
        background: white;
        margin-top: 15px;
    }

    .relative-1 {
        position: relative;
        z-index: 1;
    }

    .form-panel {
        margin: 14px;
        background: white;
        border-radius: 7px;
        box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.19);
        padding: 31px 38px;
    }

    .form-item {
        background: #f1f0f1;
        border-radius: 100px;
    }

    .form-item > input {
        background: none;
        border: none;
        outline: none;
        box-shadow: none;
        color: #333333;
    }

    .form-item:not(:first-child) {
        margin-top: 18px;
    }

    .form-button {
        padding: 9px 22px;
        background: #43baeb;
        color: white;
        border-radius: 100px;
        margin-top: 18px;
        text-align: center;
        font-size: 14px;
        letter-spacing: 2px;
    }

    .form-button:active {
        background: #33aacb;
    }

    .form-input {
        width: 100%;
        padding: 10px 22px;
        font-size: 14px;
        box-sizing: border-box;
    }

    input::-webkit-input-placeholder {
        color: #aaaaaa;
    }
</style>